<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-14 10:32:27
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 15:23:25
-->
<template>
  <ux-form
    ref="form"
    :data="formData"
    :colon="true"
    :rules="rules"
    width="720px"
    label-width="100px"
    data-automation="addAccess"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.addAccess.name')" required prop="name">
      <ux-input
        v-model="formData.name"
        :placeholder="$t('HT.rules.addAccess.name')"
        :maxlength="50"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addAccess.type')" prop="type">
      <ux-select
        v-model="formData.type"
        :options="$opt.accessType"
        :placeholder="$t('HT.rules.addAccess.type')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          type: '',
          ip_address: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addAccess()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-access {
  width: 440px;
}
</style>
